
const API={
    perm:"/api/menus",//权限接口
    permlazy:"/api/menus/lazy",//返回所有菜单
    roles:"/api/roles",//角色
    roleslist:"/api/roles/all",//角色列表
    menu:"/api/roles/menu",//保存菜单
    users:"/api/users",//用户
    mcashuser:"/api/mcashuser",//mcash用户
    updatePass:"/api/users/updatePass",//修改密码
    resetPass:"/api/users/resetPass",//重置密码
    logs:"/api/logs",//修改密码
    delIpLock:"/api/users/delIpLock",//解锁
    product: "/api/product",//产品配置
    parameter: "/api/system/parameter",//系统参数配置
    limit: "/api/limit",//额度配置
    group: "/api/group/all", //催收小组
    telGroup: "/api/tel/group/all", //电销小组
    updateUserIdNnumber: '/api/users/updateUserIdNnumber',//修改用户身份证号码
    queryLink:'/api/users/queryLink',//查看还款链接
    queryClabe:'/api/users/queryClabe',//查看还款账号
}

export default API